import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
type CountdownProps = {
  label?: string;
  className?: string;
};
export function Countdown({
  label = 'Su precio promocional expira en',
  className = ''
}: CountdownProps) {
  const [secondsLeft, setSecondsLeft] = useState(START_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setSecondsLeft(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor(secondsLeft % 3600 / 60);
  const seconds = secondsLeft % 60;
  const blocks = [{
    value: pad(hours),
    unit: 'HORAS'
  }, {
    value: pad(minutes),
    unit: 'MIN'
  }, {
    value: pad(seconds),
    unit: 'SEG'
  }];
  return <div className={`w-full max-w-xs sm:max-w-sm ${className}`} data-id="element-39" data-mp="15awlkuk3igso">
      <p className="flex items-center justify-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-navy-800/70 sm:text-xs" data-id="element-40" data-mp="y0eo5vwqk1yu">
        <ClockIcon className="h-3.5 w-3.5 text-gold-600" aria-hidden="true" data-id="element-41" data-mp="t1tqa34yhudk" />
        {label}
      </p>
      <div className="mt-2 flex items-stretch justify-center gap-2" role="timer" aria-live="off" data-id="element-42" data-mp="17t2jem82hxvg">
        {blocks.map(block => <div key={block.unit} className="flex min-w-[62px] flex-1 flex-col items-center rounded-xl bg-navy-900 px-2 py-2 shadow-md sm:min-w-[74px]" data-id="element-43" data-mp="f3dkqfity9x0">
            <span className="font-display text-2xl font-bold leading-none text-white tabular-nums sm:text-3xl" data-id="element-44" data-mp="o38womk7m8y3">
              {block.value}
            </span>
            <span className="mt-1 text-[9px] font-bold tracking-[0.16em] text-gold-400" data-id="element-45" data-mp="k3rqts0vf9se">
              {block.unit}
            </span>
          </div>)}
      </div>
    </div>;
}